import axiosInstance from '@/services/axiosInstance';
import type {
  ProcessBillingServerGetResponse,
  ProcessBillingServerPatchRequest,
  ProcessBillingServerPostRequest,
  ProcessBillingServerPostResponse,
} from '@/types/processBillingServer.types';
import { type AxiosError } from 'axios';
import type { GenericErrorResponse } from '@brainvaulttech/dgr-react-sdk';

export async function getProcessBillingServer(workOrderId: string): Promise<ProcessBillingServerGetResponse> {
  const response = await axiosInstance.get<ProcessBillingServerGetResponse>(
    `/work-orders/${workOrderId}/process-billing-server`
  );
  return response.data;
}

export async function postProcessBillingServer(
  workOrderId: string,
  body: ProcessBillingServerPostRequest
): Promise<ProcessBillingServerPostResponse> {
  const response = await axiosInstance.post<ProcessBillingServerPostResponse>(
    `/work-orders/${workOrderId}/process-billing-server`,
    body
  );
  return response.data;
}

export async function patchProcessBillingServer(
  workOrderId: string,
  body: ProcessBillingServerPatchRequest
): Promise<{ message: string }> {
  const response = await axiosInstance.patch<{ message: string }>(
    `/work-orders/${workOrderId}/process-billing-server`,
    body
  );
  return response.data;
}

export function isProcessBillingNotFoundError(err: unknown): boolean {
  const ax = err as AxiosError<GenericErrorResponse>;
  if (ax?.response?.status !== 404) return false;
  // For this endpoint, 404 means "no process billing exists yet" for this work order.
  // Treat all 404s as not-found state so UI can render the create CTA.
  return true;
}

export interface SendAffidavitRequest {
  documentIds: string[];
  mode: 'AFFIDAVIT' | 'AFFIDAVIT_WITH_INVOICE';
}

export interface SendAffidavitResponse {
  sentTo: string[];
  cc: string[];
}

export async function sendProcessBillingAffidavit(
  workOrderId: string,
  body: SendAffidavitRequest
): Promise<SendAffidavitResponse> {
  const response = await axiosInstance.post<SendAffidavitResponse>(
    `/work-orders/${workOrderId}/process-billing-server/send-affidavit`,
    body
  );
  return response.data;
}
